import { action } from 'satcheljs';
import { Datapoints } from '../datapoints';

export const setSubject = action('setSubject', (subject: string) => ({
    subject,
}));

export const setIsShown = action('setIsShown', (isShown: boolean) => ({
    isShown,
}));

export const setFolderId = action('setFolderId', (folderId: string) => ({
    folderId,
}));

export const setIsFocused = action('setIsFocused', (isFocused: boolean) => ({
    isFocused,
}));

export const addTodo = action('addTodo', (subject: string, folderId: string) => ({
    subject,
    folderId,
    datapointConfig: Datapoints.todoItemActionCreate.datapoint(),
}));
